export default {"src":"/_next/static/media/logo_bf_1_wh.7ac45528.svg","height":37,"width":224,"blurWidth":0,"blurHeight":0};